import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "conwrap"
};
const _hoisted_2 = {
  class: "coninfo"
};
const _hoisted_3 = {
  key: 0,
  class: "contitle"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 3,
  class: "codeeditor"
};
const _hoisted_7 = {
  class: "ceright"
};
const _hoisted_8 = {
  class: "conpreview",
  ref: "iframepreview",
  scrolling: "auto"
};
const _hoisted_9 = {
  key: 0,
  class: "conside"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  key: 1,
  class: "mediavideo"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-bofang"
})], -1);
const _hoisted_14 = ["src"];
export default {
  __name: 'Csitcoursecon',
  props: {
    coursecur: {
      type: Object,
      default: () => {}
    }
  },
  setup(__props) {
    const props = __props;
    const data = reactive({
      isshowvideo: false,
      videocur: ''
    });
    const {
      proxy
    } = getCurrentInstance();
    function showvideo() {
      data.isshowvideo = true;
      data.videocur = props.coursecur.video;
    }
    function codepreview() {
      let isload = false;
      proxy.$nextTick(() => {
        if (proxy.$refs) {
          if (proxy.$refs["iframepreview"]) {
            let iobj = proxy.$refs["iframepreview"].contentDocument;
            if (iobj) {
              isload = true;
              let strhtml = props.coursecur.concode;
              if (strhtml) {
                iobj.head.innerHTML = '';
                let reg = /<script[\s\S]*?>([\s\S]*?)<\/script>/gims;
                let ms = strhtml.match(reg);
                proxy.$common.each(ms, () => {
                  let cm = reg.exec(strhtml);
                  let x = iobj.createElement("SCRIPT");
                  let t = iobj.createTextNode(cm[1]);
                  x.appendChild(t);
                  iobj.head.appendChild(x);
                });
                strhtml = strhtml.replace(reg, '');
              }
              iobj.querySelector('body').innerHTML = strhtml;
            }
          }
        }
        if (!isload) {
          window.setTimeout(() => {
            codepreview();
          }, 100);
        }
      });
    }
    onMounted(() => {
      codepreview();
    });
    watch(() => props.coursecur.concode, () => {
      codepreview();
    });
    return (_ctx, _cache) => {
      const _component_v_md_editor = _resolveComponent("v-md-editor");
      const _component_Csitcoursecon = _resolveComponent("Csitcoursecon", true);
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!__props.coursecur.ismenu && __props.coursecur.title ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.coursecur.title), 1)) : _createCommentVNode("", true), __props.coursecur.content ? (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: "editor2",
        innerHTML: __props.coursecur.content
      }, null, 8, _hoisted_4)) : _createCommentVNode("", true), __props.coursecur.txtcode ? (_openBlock(), _createElementBlock("span", {
        key: 2,
        class: "editor2",
        innerHTML: __props.coursecur.txtcode
      }, null, 8, _hoisted_5)) : _createCommentVNode("", true), __props.coursecur.concode ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
        class: "celeft",
        onKeyup: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [_createVNode(_component_v_md_editor, {
        modelValue: __props.coursecur.concode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => __props.coursecur.concode = $event),
        class: "mdeditor",
        "right-toolbar": "",
        "left-toolbar": "undo redo",
        mode: "edit"
      }, null, 8, ["modelValue"])], 32), _createElementVNode("div", _hoisted_7, [_createElementVNode("iframe", _hoisted_8, null, 512)])])) : _createCommentVNode("", true), __props.coursecur.x_haschildren ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 4
      }, _renderList(__props.coursecur.x_children, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "coninfo2",
          key: item.id
        }, [!item.ismenu ? (_openBlock(), _createBlock(_component_Csitcoursecon, {
          key: 0,
          coursecur: item
        }, null, 8, ["coursecur"])) : _createCommentVNode("", true)]);
      }), 128)) : _createCommentVNode("", true)]), __props.coursecur.x_hasmedia ? (_openBlock(), _createElementBlock("dl", _hoisted_9, [__props.coursecur.imgs ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(__props.coursecur.x_imglist, item => {
        return _openBlock(), _createElementBlock("dd", {
          key: item
        }, [_createElementVNode("img", {
          src: item
        }, null, 8, _hoisted_10)]);
      }), 128)) : _createCommentVNode("", true), __props.coursecur.video ? (_openBlock(), _createElementBlock("dd", _hoisted_11, [_createElementVNode("a", {
        href: "#",
        onClick: _cache[2] || (_cache[2] = $event => showvideo())
      }, [_createElementVNode("img", {
        src: __props.coursecur.videoimg,
        class: "noviewer"
      }, null, 8, _hoisted_12), _hoisted_13])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _unref(data).isshowvideo && _unref(data).videocur ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 1,
        modelValue: _unref(data).isshowvideo,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(data).isshowvideo = $event),
        class: "mydialog",
        "append-to-body": true
      }, {
        default: _withCtx(() => [_createElementVNode("video", {
          src: _unref(data).videocur,
          controls: "",
          autoplay: "",
          controlslist: "nodownload",
          onContextmenu: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
        }, null, 40, _hoisted_14)]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true)]);
    };
  }
};